import { Sale } from '@qogita/canary-types';
import { useQuery } from '@tanstack/react-query';

import { ERRORS } from '#src/constants/copy';
import { env } from '#src/env.mjs';
import { FailedToFetchError } from '#src/utils/errors';
import { getAccessToken } from '#utils/authentication';
import { getResponse } from '#utils/getResponse';
import { getSaleQueryKey } from '#utils/queryKey';

type Variables = {
  saleQid: string;
};

type GetSaleProps = Variables;

const getSale = async ({ saleQid }: GetSaleProps) => {
  const response = await fetch(
    `${env.NEXT_PUBLIC_API_BASE_URL}/sales/${saleQid}/`,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${await getAccessToken()}`,
      },
    },
  ).catch(() => {
    throw new FailedToFetchError(ERRORS.failedToFetch);
  });

  return await getResponse<Sale>({
    name: 'getSale',
    response,
    defaultErrorMessage: ERRORS.getSale.default,
    getErrorMessage: {
      404: () => ERRORS.getSale[404],
    },
  });
};

export const useGetSale = ({
  saleQid,
  enabled = true,
}: {
  saleQid: string;
  enabled?: boolean;
}) => {
  return useQuery<Sale, TypeError | Error>({
    enabled,
    queryKey: getSaleQueryKey(saleQid),
    queryFn: () => {
      return getSale({
        saleQid,
      });
    },
  });
};
